module.exports = __webpack_public_path__ + "img/logivote.ed623d94.png";